import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorPageMessageDirective } from './directives/error-page-message.directive';
import { ErrorPageTitleDirective } from './directives/error-page-title.directive';
import { ErrorPageActionDirective } from './directives/error-page-action.directive';
import { ErrorPageComponent } from './components/error-page.component';

@NgModule({
  declarations: [
    ErrorPageComponent,
    ErrorPageTitleDirective,
    ErrorPageMessageDirective,
    ErrorPageActionDirective,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ErrorPageComponent,
    ErrorPageTitleDirective,
    ErrorPageMessageDirective,
    ErrorPageActionDirective,
  ],
})
export class ErrorPageModule {}
